import { type SanityFrameBuilderStrings } from '@frame-builder/data/sanity/queries/types/strings'
import { getSizeString } from '@lib/size'
import { type FrameBuilderState, type SelectionMessages } from './types'

/**
 * Gets artwork size selection.
 */
export const getArtworkSizeSelection = (
  state: FrameBuilderState,
  frameBuilderStrings: SanityFrameBuilderStrings,
): SelectionMessages => {
  const artworkWidth = state.artwork.width
  const artworkHeight = state.artwork.height
  const partialSelectionMessages: SelectionMessages = {}

  if (
    typeof artworkWidth !== 'undefined' &&
    typeof artworkHeight !== 'undefined'
  ) {
    const artworkSizeString = getSizeString(artworkWidth, artworkHeight, {
      spacingAroundSeparator: true,
    })
    partialSelectionMessages.artworkSize = `${artworkSizeString} ${frameBuilderStrings.lengthUnitLabel}`
  }

  return partialSelectionMessages
}

/**
 * Gets artwork image selection.
 */
export const getArtworkImageSelection = (
  state: FrameBuilderState,
): SelectionMessages => {
  const image = state.artwork.image
  const partialSelectionMessages: SelectionMessages = {}

  if (typeof image !== 'undefined') {
    partialSelectionMessages.artworkImage = image.name
  }

  return partialSelectionMessages
}

/**
 * Gets frame style selection.
 */
export const getFrameStyleSelection = (
  state: FrameBuilderState,
): SelectionMessages => {
  const profile = state.profile
  const texture = state.texture
  const partialSelectionMessages: SelectionMessages = {}

  if (typeof profile !== 'undefined' && typeof texture !== 'undefined') {
    partialSelectionMessages.frameStyle = [texture.title, profile.title]
      .filter(Boolean)
      .join(' | ')
  }

  return partialSelectionMessages
}

/**
 * Gets mount selection.
 */
export const getPassepartoutSelection = (
  state: FrameBuilderState,
): SelectionMessages => {
  const passepartoutColor = state.passepartout.color
  const partialSelectionMessages: SelectionMessages = {}

  if (typeof passepartoutColor !== 'undefined') {
    partialSelectionMessages.passepartout = [passepartoutColor.title]
      .filter(Boolean)
      .join(' | ')
  }

  return partialSelectionMessages
}

/**
 * Gets glass selection.
 */
export const getGlassSelection = (
  state: FrameBuilderState,
): SelectionMessages => {
  const glass = state.glass
  const partialSelectionMessages: SelectionMessages = {}

  if (typeof glass !== 'undefined') {
    partialSelectionMessages.glass = glass.title
  }

  return partialSelectionMessages
}

/**
 * Gets spacer selection.
 */
export const getSpacerSelection = (
  state: FrameBuilderState,
): SelectionMessages => {
  const spacerSize = state.spacerSize
  const spacerColor = state.spacerColor
  const partialSelectionMessages: SelectionMessages = {}

  if (typeof spacerSize !== 'undefined' && typeof spacerColor !== 'undefined') {
    const colorTitle = spacerSize.thickness > 0 ? spacerColor.title : undefined
    partialSelectionMessages.spacer = [spacerSize.title, colorTitle]
      .filter(Boolean)
      .join(' | ')
  }

  return partialSelectionMessages
}
